import React from 'react';
import { useI18n } from '../hooks/useI18n';

const LanguageSelector = () => {
  const { getCurrentLanguage, changeLanguage } = useI18n();
  const currentLang = getCurrentLanguage();

  return (
    <div className="inline-flex rounded-lg border border-gray-100 bg-white/90 backdrop-blur-sm shadow-sm">
      <button
        onClick={() => changeLanguage('en')}
        className={`inline-flex items-center justify-center p-1 rounded-l-lg overflow-hidden ${
          currentLang === 'en'
            ? 'ring-2 ring-blue-500'
            : 'hover:ring-2 hover:ring-gray-200'
        }`}
        style={{ width: '24px', height: '18px' }}
      >
        <img 
          src="/images/flags/us.svg" 
          alt="English"
          className="w-full h-full object-cover"
          style={{ 
            display: 'block',
            width: '100%',
            height: '100%'
          }}
        />
      </button>
      <button
        onClick={() => changeLanguage('zh')}
        className={`inline-flex items-center justify-center p-1 rounded-r-lg overflow-hidden ${
          currentLang === 'zh'
            ? 'ring-2 ring-blue-500'
            : 'hover:ring-2 hover:ring-gray-200'
        }`}
        style={{ width: '24px', height: '18px' }}
      >
        <img 
          src="/images/flags/cn.svg" 
          alt="中文"
          className="w-full h-full object-cover"
          style={{ 
            display: 'block',
            width: '100%',
            height: '100%'
          }}
        />
      </button>
    </div>
  );
};

export default LanguageSelector; 